import * as cookie from '@owl-nest/cookie-helper'

const UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER = 'ul_selected_3rd_party_account_provider'

export function forgetThirdPartyProvider() {
  if (sessionStorage) {
    sessionStorage.removeItem(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER)
  } else if (cookie.getCookie(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER)) {
    cookie.removeCookie(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER)
  }
}

export function memorizeThirdPartyProvider(provider: string) {
  let expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + 30)

  if (sessionStorage) {
    sessionStorage.setItem(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER, provider)
  } else {
    cookie.setCookie(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER, 'true', {
      expires: expiryDate.toUTCString(),
    })
  }
}

export function recallThirdPartyProvider(): string | undefined {
  let provider
  if (sessionStorage) {
    provider = sessionStorage.getItem(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER)
  }
  if (!provider) {
    provider = cookie.getCookie(UL_SELECTED_THIRD_PARTY_ACCOUNT_PROVIDER)
  }
  return provider
}
